import moment from 'moment'
import {
    LoggerType,
} from 'app/enums/label.enums'
import dateTimeStandardMask from 'app/utils/date/dateTimeStandardMask'

export enum ReadingThresholdType {
    OLD = 'oldReading',
    LIVE = 'liveReading',
    RECENT = 'recentReading',
}

const getThresholdsMap = (property: LoggerType | undefined) => {
    switch (property) {
    case LoggerType.MR_814:
    case LoggerType.MR_815:
        return {
            new: 360,
            old: Infinity,
        }
    default:
        return {
            new: 60,
            old: 1440,
        }
    }
}

const getReadingThresholdType = (dateOnUtc: string, specialColorCodingProperty?: LoggerType) => {
    if (!dateOnUtc) {
        return undefined
    }
    const minutesPassed = moment().diff(moment.utc(dateOnUtc, dateTimeStandardMask), 'minutes')
    const threshold = getThresholdsMap(specialColorCodingProperty)

    if (minutesPassed >= threshold.old) {
        return ReadingThresholdType.OLD
    }
    if (minutesPassed < threshold.new) {
        return ReadingThresholdType.LIVE
    }

    return ReadingThresholdType.RECENT
}

export default getReadingThresholdType
